<template>
  <div class="training-wrapper">
    <!-- training list -->
    <div class="training-widget" v-if="is_items_list_open">
      <ul class="training-items" v-if="profile_data.trainings.length > 0">
        <li class="training-starter">
          <div class="training-item-header">
            <label
              >Trainings ({{ profile_data.trainings.length | validate }})</label
            >
            <button class="btn-add" @click="addUpdateForm()">
              Add Training +
            </button>
          </div>
        </li>
        <li
          class="training-item"
          v-for="(item, i) in profile_data.trainings"
          :key="i"
        >
          <panel-expand :expand="i === 0">
            <template v-slot:header="{ options }">
              <div class="training-item-header">
                <div class="training-item-brand">
                  <img src="@/assets/icons/icon__edication.svg" alt />
                </div>
                <div class="content">
                  <div class="title-row">
                    <label>{{ item.organization | validate }}</label>
                    <span>{{ item.title | validate }}</span>
                  </div>
                  <div class="options">
                    <dropdown-menu>
                      <ul>
                        <li>
                          <a href @click.prevent="editTraining(item)"
                            >Edit Training</a
                          >
                        </li>
                        <li>
                          <app-dialog
                            title="Delete Training"
                            ask="Are you sure you want to permanently delete this Training?"
                            yesText="Delete"
                            yesBtnClass="btn-danger"
                            noText="Cancel"
                            @onComfirm="deleteTraining(item.id, i)"
                          >
                            <a href="#">Delete Training</a>
                          </app-dialog>
                        </li>
                      </ul>
                    </dropdown-menu>
                    <span class="date">
                      <span v-if="item.from">{{
                        item.from | formatDate | validate
                      }}</span>
                      <span class="separator" v-if="item.from && item.to"
                        >-</span
                      >
                      <span v-if="item.to">{{
                        item.to | formatDate | validate
                      }}</span>
                    </span>

                    <button
                      class="toogle-panel-btn"
                      @click="options.expanded = !options.expanded"
                      v-if="!options.expanded"
                    >
                      <img src="@/assets/admin-icon/icon-down.svg" />
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:main="{ options }">
              <div class="training-item-body">
                <div class="training-info">
                  <h5>Location</h5>
                  <p>
                    <span v-if="item.address">{{
                      item.address | validate
                    }}</span>
                  </p>
                </div>
                <div class="training-item-body-option">
                  <button
                    class="toogle-panel-btn"
                    @click="options.expanded = !options.expanded"
                  >
                    <span
                      class="fa fa-angle-up"
                      v-show="options.expanded"
                    ></span>
                  </button>
                </div>
              </div>
            </template>
          </panel-expand>
        </li>
      </ul>
      <div class="empty-widget" v-else>
        <div class="empty-widgetheader">
          <label>Trainings</label>
        </div>
        <div class="empty-widget-body">
          <p>
            You have not yet added trainings yet,
            <br />Click below to add one
          </p>
          <button class="add-btn" @click="addUpdateForm()">Add training</button>
        </div>
      </div>
    </div>
    <!-- Add and update form -->
    <div class="add-update-form" v-if="add_update_form">
      <div class="form-add">
        <span v-if="!training.id">Add New Training</span>
        <span v-else>Update Training</span>
        <label>Institution</label>
        <input
          type="text"
          placeholder="E.g.  International Business School"
          v-model="training.organization"
        />
        <label>Time Frame</label>
        <div class="__row">
          <datepicker
            placeholder="From"
            v-model="training.from"
            input-class="input date-picker"
            wrapper-class="input"
          ></datepicker>
          <div style="width: 20px; height: 10px"></div>
          <datepicker
            placeholder="To"
            v-model="training.to"
            :disabled-dates="{ to: training.from }"
            input-class="input date-picker"
            wrapper-class="input"
          ></datepicker>
        </div>
        <label>Certificate</label>
        <input
          type="text"
          placeholder="E.g.  Certificate of Achievement."
          v-model="training.title"
        />
        <label>Location</label>
        <div class="__row">
          <map-helper v-model="training.address"></map-helper>
        </div>

        <div class="__btns">
          <consultfied-button
            :loading="save_training_loading"
            class="btn-save"
            @click="saveTraining()"
            >Save</consultfied-button
          >
          <button class="btn-cancel" @click="closeAddUpdateForm()">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dropdownMenu from "@/components/Partials/dropdownMenu";
import appDialog from "@/components/Dialog/AppDialog.vue";
import panelExpand from "@/components/Partials/panelExpand";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import Datepicker from "vuejs-datepicker";
import upload from "@/components/Partials/Uploader.vue";
import { eventBus } from "@/main";

import { mapGetters } from "vuex";
export default {
  name: "training",
  components: {
    dropdownMenu,
    appDialog,
    panelExpand,
    Datepicker,
    upload,
    consultfiedButton,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data: () => {
    return {
      training: {
        id: null,
        organization: "",
        from: "",
        to: "",
        description: "",
        degree: "",
        country: 0,
        city: 0,
        address: "",
        title: "",
        logoName: "",
        logo: null,
        logoUrl: "",
        type: "training",
      },
      add_update_form: false,
      is_items_list_open: true,
      show_verify: false,
      profile_data: {
        projects: [],
        skills: {
          tools: [],
          domains: [],
          languages: [],
          competences: [],
          roles: [],
        },
        employment: [],
        educations: [],
        trainings: [],
        certifications: [],
        tags: [],
        notifications: [],
        user: {},
        profile: {},
      },
      save_training_loading: false,
    };
  },
  mounted() {
    let vm = this;
    vm.getProfileData();
    vm.$store.dispatch("GET_COUNTRIES");
  },
  computed: {
    ...mapGetters(["getCountries", "getCities"]),
  },
  methods: {
    deleteTraining(id, i) {
      let vm = this;
      vm.$store
        .dispatch("DELETE_QUALIFICATION_ITEM", {
          id: id,
          user_id: vm.id,
          type: "training",
        })
        .then((responce) => {
          if (i > -1) {
            vm.profile_data.trainings.splice(i, 1);
          }
        })
        .catch((error) => {
          console.log({ error });
        });
    },
    editTraining(item) {
      let vm = this;
      vm.add_update_form = true;
      vm.is_items_list_open = false;
      vm.training.id = item.id;
      vm.training.organization = item.organization;
      vm.training.from = vm.$dateObj(item.from);
      vm.training.to = vm.$dateObj(item.to);
      vm.training.description = item.description || "";
      vm.training.degree = item.degree || "";
      vm.training.country = vm.$hasKey(item, "location.country.id")
        ? item.location.country.id
        : 0;
      vm.$store.dispatch("GET_CITIES", {
        country: vm.$hasKey(item, "location.country.id")
          ? item.location.country.id
          : 0,
      });
      vm.training.city = vm.$hasKey(item, "location.city.id")
        ? item.location.city.id
        : 0;
      vm.training.address = "";
      vm.training.completed_year = "";
      vm.training.title = item.title;
      vm.training.logoName = item.logo;
      vm.training.logo = null;
      vm.training.logoUrl = item.logo;
    },
    saveTraining() {
      let vm = this;
      vm.save_training_loading = true;
      let postFrmData = new FormData();
      postFrmData.append("organization", vm.training.organization);
      postFrmData.append("from", vm.training.from);
      postFrmData.append("to", vm.training.to);
      postFrmData.append("description", vm.training.description);
      postFrmData.append("degree", vm.training.degree);
      postFrmData.append("country", vm.training.country);
      postFrmData.append("city", vm.training.city);
      postFrmData.append("address", vm.training.address);
      postFrmData.append("completed_year", vm.training.completed_year);
      postFrmData.append("title", vm.training.title);
      postFrmData.append("type", "training");
      if (vm.training.logo) {
        postFrmData.append("logo", vm.training.logo, vm.training.logo.name);
      }
      if (!vm.training.id) {
        // Add new
        vm.$store
          .dispatch("ADD_QUALIFICATION", postFrmData)
          .then((responce) => {
            vm.save_training_loading = false;
            vm.getProfileData();
          })
          .catch((error) => {
            vm.save_training_loading = false;
            console.log({ error });
          });
      } else {
        // Update
        postFrmData.append("id", vm.training.id);
        vm.$store
          .dispatch("EDIT_QUALIFICATION_ITEM", postFrmData)
          .then((responce) => {
            vm.save_training_loading = false;
            vm.getProfileData();
          })
          .catch((error) => {
            vm.save_training_loading = false;
            console.log({ error });
          });
      }
    },
    getProfileData() {
      let vm = this;
      vm.$store.dispatch("GET_CONSULTANT_DATA").then((response) => {
        let data = response.data;
        vm.profile_data = data;
        vm.showItemsList();
      });
    },
    setInstitutionLogo(file) {
      let vm = this;
      if (file) {
        vm.training.logo = file;
        vm.training.logoUrl = "";
      }
    },
    loadCities(e) {
      this.$store.dispatch("GET_CITIES", { country: e.target.value });
    },
    addUpdateForm() {
      let vm = this;
      vm.add_update_form = true;
      vm.is_items_list_open = false;
      vm.training = {
        id: null,
        organization: "",
        from: "",
        to: "",
        description: "",
        degree: "",
        country: 0,
        city: 0,
        address: "",
        title: "",
        logoName: "",
        logo: null,
        logoUrl: "",
      };
    },
    closeAddUpdateForm() {
      let vm = this;
      vm.add_update_form = false;
      vm.is_items_list_open = true;
    },
    showItemsList() {
      let vm = this;
      vm.add_update_form = false;
      vm.is_items_list_open = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.training-wrapper {
  @media (min-width: 300px) and (max-width: 630px) {
    padding: 10px;
  }
  .training-widget {
    ul.training-items {
      padding: 0px 10px;
      padding-bottom: 20px;
      list-style: none;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      .training-starter {
        margin-bottom: 6px;
        .training-item-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 0px;
          label {
            color: #000000;
            font-family: "AvenirBook";
            font-size: 16px;
          }
          .btn-add {
            color: #1ba5a4;
            border: none;
            padding: 10px 10px;
            font-size: 14px;
            outline: none;
            cursor: pointer;
            font-family: "AvenirBook";
            font-style: italic;
            background: transparent;
          }
        }
        p {
          color: #131313;
          font-family: "AvenirBook";
        }
      }
      .training-item {
        background: #ffffff;
        border-radius: 5px;
        margin-bottom: 10px;
        position: relative;
        .training-item-header {
          display: grid;
          padding: 10px 10px;
          grid-template-columns: 90px calc(97% - 90px);
          grid-column-gap: 20px;
          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: 100%;
            grid-column-gap: 10px;
            padding: 10px 12px;
          }
          .training-item-brand {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 90px;
            height: 90px;
            background: rgb(228, 228, 228);
            border-radius: 50%;
            @media (min-width: 300px) and (max-width: 630px) {
              width: 60px;
              height: 60px;
              display: none;
            }
            img {
              width: 70px;
              height: 70px;
              object-fit: contain;
              @media (min-width: 300px) and (max-width: 630px) {
                width: 33px;
                height: 33px;
              }
            }
          }

          .content {
            display: flex;
            justify-content: space-between;

            .title-row {
              font-family: "AvenirBook";
              padding-right: 9px;
              display: flex;
              flex-direction: column;
              justify-content: center;

              label {
                display: block;
                font-size: 14px;
                font-family: "AvenirBlack";
                margin-bottom: 1px;
                font-weight: 800;
                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 12px;
                }
              }

              span {
                color: #808080;
                font-family: "AvenirBook";
                font-size: 13px;
                margin-bottom: 6px;
                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 12px;
                }
              }
            }
            .options {
              display: flex;
              align-items: flex-end;
              flex-direction: column;
              .btns {
                display: flex;
                margin-top: -11px;
              }
              .verified-status {
                color: #0590ab;
                margin: 10px 0px;
              }
              .btn-verify {
                height: 40px;
                width: 100px;
                outline: none;
                color: #fff;
                background-color: #1890a9;
                border-radius: 5px;
              }
              .date {
                color: #808080;
                font-family: "AvenirBook";
                font-size: 13px;
                display: flex;
                justify-content: flex-end;
                width: 188px;
                align-items: center;
                margin-bottom: 22px;
                .separator {
                  margin: 0px 5px;
                }
                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 11px;
                  width: 145px;
                }
              }

              .status {
                color: #000;
                font-family: "AvenirBook";
                font-size: 13px;
              }

              .toogle-panel-btn {
                width: 19px;
                padding: 0;
                height: 22px;
                font-size: 20px;
                position: absolute;
                bottom: 5px;
                right: 7px;
              }
            }
          }

          .toogle-panel-btn {
            padding: 1px 40px;
            font-size: 30px;
            background: transparent;
            border: none;
            outline: none;
            cursor: pointer;
            color: #ccc;
          }
        }
        .training-item-body {
          padding: 10px;
          .training-info {
            h5 {
              text-align: left;
              color: #6e6e6e;
              font-size: 14px;
            }
            p {
              text-align: left;
              color: #000;
              font-size: 13px;
              font-weight: 800;
            }
            .collaboraters-widget {
              padding: 10px 0px;
              display: flex;
              flex-wrap: wrap;
              .item {
                background: #1ba5a4 0% 0% no-repeat padding-box;
                border-radius: 20px;
                display: flex;
                align-items: center;
                padding: 4px 4px;
                margin-right: 8px;
                margin-bottom: 8px;
                .profile-img {
                  width: 26px;
                  height: 26px;
                  border-radius: 50%;
                  margin-right: 5px;
                }
                .name {
                  color: #fff;
                }
              }
            }
            .skills-widget {
              .skills_content__wrapper {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                grid-column-gap: 10px;
                margin-bottom: 10px;
                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 1fr;
                }
                .skill_box {
                  min-width: 0;
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  background: #fff;
                  border-radius: 5px;
                  margin-bottom: 15px;
                  .skill_box_header {
                    border-bottom: 2px solid #f5f5f5;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    padding: 0px 15px;
                    label {
                      color: #0884af;
                      width: 100%;
                      font-size: 15px;
                      font-weight: 800;
                    }
                  }
                  .skill_box_body {
                    padding: 0px 15px;
                    .empty-skills {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      height: 200px;
                      justify-content: center;
                      p {
                        text-align: center;
                        margin-bottom: 20px;
                        color: #8d8d8d;
                      }
                      button {
                        width: 133px;
                        height: 36px;
                        background: #1890a9 0% 0% no-repeat padding-box;
                        border-radius: 5px;
                        color: #fff;
                      }
                    }
                    .row__item {
                      margin-top: 10px;
                      display: flex;
                      margin-bottom: 10px;
                      justify-content: space-between;
                      width: 100%;
                      span {
                        color: #000000;
                        font-weight: normal;
                        margin-top: 2px;
                        font-size: 14px;
                        font-weight: 800;
                      }
                    }
                  }
                }
              }
              .next_skills_content__wrapper {
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-column-gap: 10px;
                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 1fr;
                }
                .skill_box {
                  min-width: 0;
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  background: #fff;
                  border-radius: 5px;
                  margin-bottom: 15px;
                  .skill_box_header {
                    border-bottom: 2px solid #f5f5f5;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    padding: 0px 15px;
                    label {
                      color: #0884af;
                      width: 100%;
                      font-size: 15px;
                      font-weight: 800;
                    }
                  }
                  .skill_box_body {
                    padding: 0px 15px;
                    .empty-skills {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      height: 200px;
                      justify-content: center;
                      p {
                        text-align: center;
                        margin-bottom: 20px;
                        color: #8d8d8d;
                      }
                      button {
                        width: 133px;
                        height: 36px;
                        background: #1890a9 0% 0% no-repeat padding-box;
                        border-radius: 5px;
                        color: #fff;
                      }
                    }
                    .row__item {
                      margin-top: 10px;
                      display: flex;
                      margin-bottom: 10px;
                      justify-content: space-between;
                      width: 100%;
                      span {
                        color: #000000;
                        font-weight: normal;
                        margin-top: 2px;
                        font-size: 14px;
                        font-weight: 800;
                      }
                    }
                  }
                }
              }
            }
          }
          .training-item-body-option {
            display: flex;
            justify-content: flex-end;
            .toogle-panel-btn {
              padding: 1px 9px;
              font-size: 30px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
              height: 36px;
              width: 19px;
              padding: 0;
              height: 22px;
              font-size: 20px;
              position: relative;
              top: -3px;
              right: -5px;
            }
          }
        }
      }
    }
    .empty-widget {
      background: #fff;
      padding: 20px;
      .empty-widget-body {
        height: 350px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        p {
          text-align: center;
          width: 270px;
        }
        .add-btn {
          width: 180px;
          height: 45px;
          background: #1890a9 0% 0% no-repeat padding-box;
          border-radius: 4px;
          color: #fff;
          outline: none;
          margin-right: 20px;
          display: center;
          justify-content: center;
        }
      }
    }
  }
  .verify-form {
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    @media (min-width: 300px) and (max-width: 630px) {
      padding: 0px;
    }
    .project-form {
      background: #f5f5f5;
      padding: 20px;
      @media (min-width: 300px) and (max-width: 630px) {
        padding-top: 18px;
        padding-left: 11px;
        padding-right: 11px;
        padding-bottom: 39px;
      }
    }
    .__label {
      margin-bottom: 8px;
      display: block;
    }
    .input-group {
      display: grid;
      input {
        width: 100%;
        height: 40px;
        background: #fff;
        padding: 0px 13px;
        border-radius: 5px;
        outline: none;
      }
    }
    .__btns {
      display: flex;
      width: 30%;
      margin-top: 30px;
      justify-content: space-between;
      .cancel {
        color: #1ba5a4;
        cursor: pointer;
        font-weight: normal;
        height: 30px;
        padding: 3px 20px;
        font-size: 14px;
      }
      .save {
        background: #1ba5a4;
        color: #fff;
        font-size: 14px;
        font-weight: normal;
        cursor: pointer;
        border-radius: 5px;
        height: 30px;
        padding: 3px 10px;
        &:disabled {
          background: #8d8d8d;
          opacity: 0.3;
        }
      }
    }
  }
  .add-update-form {
    .form-add {
      display: flex;
      flex-direction: column;
      padding-right: 20px;
      padding-left: 20px;
      padding-bottom: 50px;
      .__row {
        display: flex;
        .institution_logo {
          width: 200px;
          height: 240px;
        }
      }
      .__rowd {
        display: flex;
        margin-bottom: 20px;
        justify-content: space-between;
        span {
          color: #000000;
          font-size: 13px;
          font-weight: normal;
        }
        button {
          background: transparent;
          outline: none;
          color: #680404;
          width: 118px;
          margin-top: 25px;
          border-radius: 5px;
          border: 0.5px solid #7e0505;
          height: 27px;
          img {
            margin-left: 10px;
          }
        }
      }
      .__title {
        font-size: 21px;
        margin-top: 10px;
        color: #1ba5a4;
        font-weight: normal;
      }
      span {
        color: #000;
        font-size: 13px;
        margin-top: 30px;
      }
      h2 {
        font-size: 14px;
        font-weight: normal;
        margin-top: 20px;
      }
      label {
        font-size: 14px;
        color: #676767;
        margin-top: 20px;
        font-weight: normal;
        margin-bottom: 5px;
      }
      .top {
        margin-top: 10px;
      }
      .__colored {
        color: #1885ad !important;
        margin-top: 20px;
      }
      input,
      textarea,
      .input,
      select {
        background: #fff;
        font-size: 12px;
        resize: none;
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 0px 20px !important;
        outline: none;
        border-radius: 5px;
        border: 1px solid #ddd;
        color: #000;
        height: 45px;
      }

      select {
        width: 100%;
      }
      textarea {
        min-height: 80px;
        padding: 10px;
      }
      .__save {
        display: flex;
        margin-top: 20px;
        button {
          background: #1ba5a4;
          border: 0.21px solid #666666;
          border-radius: 5px;
          color: #fff;
          padding: 7px 35px;
          outline: none;
        }
        .__none {
          background: none;
          border: none;
          box-shadow: none;
          margin-left: 10px;
          color: #1ba5a4;
        }
      }
      .__btns {
        display: flex;
        width: 30%;
        margin-top: 30px;
        justify-content: space-between;
        .btn-cancel {
          color: #1ba5a4;
          cursor: pointer;
          font-weight: normal;
          height: 40px;
          padding: 3px 20px;
          font-size: 14px;
          width: 100px;
        }
        .btn-save {
          background: #1ba5a4;
          color: #fff;
          font-size: 14px;
          font-weight: normal;
          cursor: pointer;
          border-radius: 5px;
          height: 40px;
          width: 100px;
          padding: 3px 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          &:disabled {
            background: #8d8d8d;
            opacity: 0.3;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.date-picker {
  height: 45px;
}
</style>